/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/accordion.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/button.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/rail.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import './styles.scss'
import { TypescriptComponent } from 'components/typescriptExample'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Image, Link, UpdateNote } from '@ta-interaktiv/contentbricks'
import Tab from 'components/tab'
import BarChart from 'components/barChartHistory'
// import { qanda } from './qa'
import TabMobile from 'components/tabMobile'
import Overlay from 'components/overlay'
import { victims } from './victims'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import SlidingPane from 'components/slidingpane'
import { parseHostname } from '@ta-interaktiv/parse-hostname'

// import { Accordion } from 'semantic-ui-react'
// import TextExpander from 'components/ToggleText'
// import BarChart from 'components/barChartHistory'
// import Scrollchor from 'react-scrollchor'
const isMobile = browserCheck.isMobile
const isMobileSmall = window.innerWidth < 376

// TODO Set the correct article ID here
const ARTICLE_ID = '160890463892'
const PUB_NAME = parseHostname().publicationName

export class AppComponent extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = {
      activeIndex: null,
      width: window.innerWidth
    }
  }
  componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange)
  }
  // make sure to remove the listener
  // when the component is not mounted anymore
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange)
  }
  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth })
  }

  handleClick = (e, titleProps) => {
    const { index } = titleProps
    if (index === this.state.activeIndex) {
      this.setState({ activeIndex: null })
      window.document.body.style.overflowY = 'auto'
    } else {
      this.setState({
        activeIndex: index
      })
      window.document.body.style.overflowY = 'hidden'
    }

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: 'toggle tab: ' + titleProps.index
    })
  }

  toggleSidestory = e => {
    let targetPane = e.currentTarget.getAttribute('data-target')
    let clickedText = e.currentTarget.getAttribute('data-story')
    if (targetPane === 'paneOne') {
      this.setState({
        isPaneOneOpen: true
      })
    } else if (targetPane === 'paneTwo') {
      this.setState({
        isPaneTwoOpen: true
      })
    }
  }

  render() {
    return (
      <>
        <Overlay
          handleClick={this.handleClick}
          activeIndex={this.state.activeIndex}
          width={this.state.width}
        ></Overlay>
        <div
          className='index'
          style={
            this.state.activeIndex
              ? { overflow: 'hidden' }
              : { overflow: 'auto' }
          }
        >
          <Masthead articleId={ARTICLE_ID} inverted />
          <ThemeSwitch />

          <header className='ui titleImage inverted'>
            <div className='ui container'>
              <div className='ui header headline'>
                <div className='headerWrapper'>
                  <h1>Elles ont été tuées par leur conjoint avec une violence extrême</h1>
                  {!isMobileSmall && (
                    <h2>
                      Pour tenter de cerner cette violence masculine, nous avons
                      scanné l’année 2018 qui recense quinze féminicides. Nous
                      avons reconstitué chaque cas. Cette série de récits révèle
                      un phénomène de société qui n’est pas une fatalité.
                    </h2>
                  )}
                  {isMobileSmall && (
                    <h2>
                      Pour tenter de cerner cette violence masculine, nous avons
                      scanné l’année 2018 qui recense 15 féminicides. Nous avons
                      reconstitué chaque cas.
                    </h2>
                  )}
                </div>
              </div>
            </div>
            <div className='Wrapper'>
              <div className='womenVictim' />
            </div>
          </header>
          {/* <div className='ui vertical inverted segment'>
          <div className='blood'></div>
        </div> */}
          <div className='ui vertical inverted segment'>
            <div className='ui text container' style={{ position: 'relative' }}>
              <div className='ta metainfo'>
                <div className='ta author'>
                  Dominique Botti, Roland Gamp, Philippe Stalder et Patrick
                  Vögeli
                </div>
                <div className='ta updated'>Mis à jour le 11 mars 2021</div>
              </div>
              <div className='ta text'>
                <p>
                  Le 2 mars 2018 à 15 h 15, Paul S* est chez lui à Brigue (VS).
                  Il est stressé, mais déterminé. Le père de famille, un notable
                  local, prend son téléphone et appelle la police cantonale. «Je
                  viens de tuer ma femme avec un marteau», annonce-t-il à
                  l’agent. L’homme a été condamné à 18 ans de prison en juin
                  2020. Il a fait recours.
                </p>

                <p>
                  Paul S.* n’est pas le seul à avoir tué sa compagne en Suisse.
                  L’Office fédéral de la statistique indique que 135 femmes ont
                  été tuées par leur mari de 2009 à 2018. Soit une par mois en
                  moyenne. Le maricide (terme utilisé pour signifier que c’est
                  la femme qui tue son compagnon) est, à l’inverse, beaucoup
                  plus rare: 16 maricides, durant la même période, soit 8,5 fois
                  moins.
                </p>

                <div className='graphicContainer'>
                  <div className='womenIconWrapper'>
                    <img src={require('../../images/men.svg')}></img>
                    <img src={require('../../images/women.svg')}></img>
                    <img src={require('../../images/women.svg')}></img>
                    <img src={require('../../images/women.svg')}></img>
                    <img src={require('../../images/women.svg')}></img>
                    <img src={require('../../images/women.svg')}></img>
                    <img src={require('../../images/women.svg')}></img>
                    <img src={require('../../images/women.svg')}></img>
                    <img src={require('../../images/women.svg')}></img>
                    <img src={require('../../images/women-half.svg')}></img>
                  </div>
                  <div className='iconText'>
                    Les femmes meurent{' '}
                    <span className='textMarker'>8,5 fois</span> plus souvent
                    par leur (ex&#8209;)partenaire
                  </div>
                </div>

                <p>
                  Ce haut risque de mourir dans la sphère familiale pour les
                  femmes par rapport aux hommes est une tendance mondiale. L’ONU
                  avait montré qu’en 2017 près de{' '}
                  <Link href='https://www.onufemmes.fr/nos-actualites/2019/11/25/feminicides-etat-des-lieux-de-la-situation-dans-le-monde'>
                    50’000 femmes avaient été tuées
                  </Link>{' '}
                  par leur compagnon dans le monde, soit 64% des homicides
                  conjugaux. En 2018, cette hécatombe féminine monte à 80% en
                  France, selon le journal{' '}
                  <Link href='https://www.lemonde.fr/societe/visuel/2020/06/01/feminicides-mecanique-d-un-crime-annonce_6041403_3224.html'>
                    «Le Monde»
                  </Link>{' '}
                  , qui a identifié 120 cas. Toujours en 2018, le journal{' '}
                  <Link href='https://www.zeit.de/2019/51/frauenmorde-gewalt-partnerschaft-bundeskriminalamt'>
                    «Die Zeit»
                  </Link>{' '}
                  a recensé 122 féminicides et 26 maricides en Allemagne.
                </p>

                <p>
                  Ces chiffres rappellent l’évidence de la violence conjugale.
                  Les hommes tuent. Les femmes beaucoup moins. Comment expliquer
                  cette réalité au XXIe siècle? Pourquoi cette persistance et
                  comment réduire les risques? Pour tenter d’y répondre, nous
                  avons radiographié l’année 2018 en Suisse. Nous avons compté
                  quinze victimes féminines. Un homme, un seul, a été tué par sa
                  partenaire. Nous avons identifié chaque cas. Puis nous avons
                  reconstitué les histoires de vie grâce aux autorités et aux
                  divers témoins, aux documents de justice et aux médias.
                </p>

                <p>
                  Cette série de récits révèle la mécanique brutale, glaçante et
                  mortelle de la violence masculine.
                </p>
              </div>
            </div>
          </div>

          <div className='ui vertical segment fitted qa'>
            <div className='ui container'>
              <div className='ui grid'>
                <div className='ui five column mobile row'>
                  {victims.map((v, index) => (
                    <>
                      <div
                        className={'column'}
                        onClick={e => {
                          this.handleClick(e, { index })
                        }}
                      >
                        <div className='card' id={index}>
                          <div className='overview'>
                            <div className='imageWrapper'>
                              {v.imageOverview}
                            </div>

                            <div className='tableWrapper'>{v.table}</div>
                            {isMobile && (
                              // <div className={'linkCardMobile' +' '+ index}>
                              <TabMobile
                                activeIndex={this.state.activeIndex}
                                index={index}
                                handleClick={this.handleClick}
                                title={v.n}
                                articleId={ARTICLE_ID}
                              />
                              // </div>
                            )}
                          </div>

                          {!isMobile && (
                            // <div className={'linkCard' +' '+ index}>
                            <Tab
                              activeIndex={this.state.activeIndex}
                              index={index}
                              handleClick={this.handleClick}
                              title={v.n}
                              articleId={ARTICLE_ID}
                            >
                              {/* <div className='question'>{q.i}</div> */}
                            </Tab>
                            // </div>
                          )}
                        </div>
                      </div>
                    </>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className='ui vertical fitted segment inverted'>
            <div
              className='ui text container ta text'
              style={{ position: 'relative' }}
            >
              <h5>Pourquoi les femmes sont-elles si souvent touchées?</h5>
              <p>
                Un genre serait-il plus cruel que l’autre? Jérôme Endrass,
                psychologue médicolégal dans le canton de Zurich, met en avant
                la différence physique. «Les hommes sont génétiquement
                différents des femmes en termes d'agressivité, de besoins
                sexuels et de force.» Certains seraient plus impulsifs, plus
                dominateurs et pourraient tomber plus facilement dans la
                violence. Il n’y a pas que cela: l’élément socioculturel est
                aussi à prendre en compte. La médecin adjointe au Département de
                psychiatrie du CHUV, à Lausanne, Alessandra Duc Marwood,
                explique que le paternalisme de notre société contribue à ce
                déséquilibre entre les genres.
              </p>

              <aside
                className='ui vertical very fitted segment widescreen hidden large screen hidden small'
                style={{ marginBottom: '1em' }}
              >
                <a
                  onClick={this.toggleSidestory}
                  data-story='Gewinne von US-Konzernen'
                  data-target='paneOne'
                >
                  <div className='image-container'>
                    <img src={require('../../images/marwood.png')} />
                  </div>
                  <div className='story-hint'>
                    <div className='icon-container'>
                      <i className='file alternate icon' />
                    </div>
                    <div className='hint-container'>
                      <div>
                        «Nous vivons dans une société encore à dominance
                        patriarcale»
                      </div>
                      <div>
                        <span className='pseudo-link'>
                          Enretien avec la Dre Alessandra Duc Marwood
                        </span>
                      </div>
                    </div>
                  </div>
                </a>
              </aside>
              <aside
                className='ui right rail computer or lower hidden'
                style={{ top: '10%' }}
              >
                <a
                  onClick={this.toggleSidestory}
                  data-story='Gewinne von US-Konzernen'
                  data-target='paneOne'
                >
                  <div className='image-container'>
                    <img src={require('../../images/marwood.png')} />
                  </div>
                  <div className='story-hint'>
                    <div className='icon-container'>
                      <i className='file alternate icon' />
                    </div>
                    <div className='hint-container'>
                      <div>
                        «Nous vivons dans une société encore à dominance
                        patriarcale»
                      </div>
                      <div>
                        <span className='pseudo-link'>
                          Enretien avec la Dre Alessandra Duc Marwood
                        </span>
                      </div>
                    </div>
                  </div>
                </a>
              </aside>

              <p>
                La lecture de ces quinze cas en 2018 permet d’affiner l’analyse.
                Les hommes ne se contentent pas de tuer. Ils s’acharnent parfois
                sur leur victime. À Wil (SG), Murat F.* donne 51 coups de
                couteau. À Payerne (VD), Victor C.* tire 30 coups de feu, vidant
                deux chargeurs. À Zurich, Alberto V.* exécute sa partenaire la
                journée, au centre-ville, en pleine rue. Dans d’autres cas, les
                auteurs blessent grièvement leur compagne, puis l’abandonnent,
                agonisante, sur le sol de l’appartement. Dario Giacomini,
                psychologue intervenant au Centre LAVI de Genève, interprète ce
                déchaînement de violence comme une volonté de faire du mal, de
                faire disparaître à tout jamais la victime. Comme si elle
                n’avait jamais existé.
              </p>
              <p>
                Daniel Zagury est expert psychiatre. Dans son livre «La barbarie
                des hommes ordinaires» (L'Observatoire), il écrit que le passage à
                l’acte criminel tient souvent à «l’épaisseur d’un cheveu». Il
                suffit d’un mot, d’un geste, d’une occasion pour déclencher
                cette agressivité extrême. Les premiers coups du tueur sont
                conscients. Pas les suivants. Le spécialiste français explique
                que certains auteurs sont sidérés d’apprendre, durant l’enquête,
                ce qu’ils ont pu faire. Ils disent ne pas se souvenir de cet
                acharnement, ni pouvoir en expliquer les raisons.{' '}
              </p>

              <h5>Il y a de nombreuses victimes collatérales</h5>

              <p>
                Dans les féminicides, il y a des victimes collatérales. Notre
                travail montre que les auteurs meurent aussi. Plusieurs se sont
                suicidés après avoir tué. La famille proche est également
                touchée. À Hausen (AG), Illir B.* poignarde sa femme et sa
                belle-sœur. Dans tous ces récits dramatiques, les enfants sont
                souvent présents. Nous en avons compté une vingtaine en 2018. Tous les âges
                sont concernés, du nourrisson à l’adulte, en passant par
                l’adolescent. Ils subissent plusieurs types de violence. Deux
                ont été tués en 2018. D’autres ont assisté malgré eux à
                l’homicide.
              </p>

              <aside
                className='ui vertical very fitted segment widescreen hidden large screen hidden small'
                style={{ marginBottom: '1em' }}
              >
                <a
                  href={`https://${PUB_NAME}.ch/534618589877`}
                >
                  <div className='story-hint'>
                    <div className='icon-container'>
                      <i className='external icon' />
                    </div>
                    <div className='hint-container'>
                      <div>
                      Les enfants sont les victimes collatérales du féminicide
                      </div>
                      <div>
                        <span className='pseudo-link'>
                        Une vingtaine d’enfants sont concernés par ces drames humains.
                        </span>
                      </div>
                    </div>
                  </div>
                </a>
              </aside>
              <aside
                className='ui right rail computer or lower hidden'
                style={{ top: '50%' }}
              >
                <a
                  href={`https://${PUB_NAME}.ch/534618589877`}
                  >
                  <div className='story-hint'>
                    <div className='icon-container'>
                      <i className='external icon' />
                    </div>
                    <div className='hint-container'>
                      <div>
                      Les enfants sont les victimes collatérales du féminicide
                      </div>
                      <div>
                        <span className='pseudo-link'>
                        Une vingtaine d’enfants sont concernés par ces drames humains.
                        </span>
                      </div>
                    </div>
                  </div>
                </a>
              </aside>

              <p>
                Pour beaucoup de mineurs, la question de l’autorité parentale,
                du placement se pose le jour même du drame. Il faut leur donner
                un toit, les rassurer. Ils sont généralement mis sous tutelle et
                placés dans un foyer, le temps de stabiliser leur état. Ce n’est
                qu’après un long travail post-traumatique que ces jeunes
                victimes collatérales peuvent relever la tête. Ils doivent
                affronter un double traumatisme: le deuil de leur mère et la
                reconstruction du lien avec leur père tueur. Si ce dernier est
                en prison, le droit de visite ne s’exerce, s’il est justifié,
                qu’après le procès.
              </p>
              <p>
                Notre radiographie de l’année 2018 montre enfin que la
                séparation conjugale est le moment le plus dangereux pour le
                couple. Les hommes passent à l’acte quand ils ont l’impression
                que tout est perdu, qu’il n’y a plus d’espoir, que leur compagne
                va retrouver sa liberté. Il n’y a pas que la rupture
                sentimentale qui marque la séparation. Il y a aussi la maladie
                incurable. À Oftringen (AG) et à Affoltern am Albis (ZH), une
                retraitée souffrante est tuée par son mari, qui a retourné
                ensuite son arme contre lui. Ensemble jusqu’à la mort.
              </p>

              <h5>Difficile de protéger les femmes menacées</h5>

              <p>
                L’annonce du divorce est un signal d’alarme pour les
                spécialistes de la prévention, selon Jérôme Endrass. C’est à ce
                moment que le réseau doit agir, rapidement. Il doit mettre à
                l’abri la femme et les enfants et éloigner le prédateur, le
                neutraliser. Ces phases critiques peuvent se répéter. «Les
                femmes ont besoin de cinq tentatives pour définitivement quitter
                un partenaire violent», explique Pia Allemann, membre du BIF,
                bureau zurichois qui lutte contre la violence conjugale.
              </p>
              <p>
                Chaque cas 2018 est particulier. Tous les âges et toutes les
                nationalités sont concernés. Des similitudes existent toutefois:
                mâles tueurs, violence extrême, orphelins, séparation. Pour le
                reste, difficile d’en savoir davantage à ce stade. Les données
                manquent. Certains féminicides ne sont jamais rendus publics. Et
                lorsqu’ils le sont, les médias les présentent souvent comme des
                drames isolés, accidentels, voire des crimes passionnels. «En
                Suisse, il y a très peu d’informations disponibles. Il n’y a pas
                d’études quantitatives systématiques sur les victimes de
                violence dans le couple. La dernière date de 1997», explique
                Marylène Lieber, professeure en études genre à l’Université de
                Genève, qui publie cet automne un ouvrage sur la violence
                conjugale. Selon cette universitaire, ce vide est dommageable.
                Le féminicide conjugal est un phénomène désormais connu et
                reconnu qui fonctionne selon une logique systémique. Les auteurs
                sont identifiables. Les victimes peuvent être aidées. Les
                institutions spécialisées existent. Mieux le comprendre permet
                de mieux le prévenir.
              </p>
              <p className='sourceMain'>*Prénom d’emprunt</p>
            </div>
          </div>

          <SlidingPane
            className='some-custom-class'
            overlayClassName='some-custom-overlay-class'
            isOpen={this.state.isPaneOneOpen}
            title='Enretien avec la Dre Alessandra Duc Marwood'
            subtitle=''
            onRequestClose={() => {
              /* triggered on "<" on left top click or on outside click */
              this.setState({ isPaneOneOpen: false })
            }}
          >
            <div className='itwp'>
              <div className='image-container'>
                <img src={require('../../images/marwood-full.jpg')} />
              </div>
              <small>
                Dre Alessandra Duc Marwood, médecin-adjointe, directrice des
                Boréales, Centre cantonal de consultation psychothérapeutique
                destiné à toute personne (enfant, adolescent·e, adulte, personne
                âgée) ayant subi ou commis des violences et/ou des abus sexuels
                dans le cadre de la famille, Département de Psychiatrie, CHUV.
              </small>
            </div>
            <p>
              <b>
                Nous avons repéré 17 homicides conjugaux en 2018. Seize ont été
                commis par des hommes. Et cette surreprésentation se vérifie
                chaque année depuis 2009. Comment expliquez-vous cela?
              </b>
            </p>
            <p>
              Nous vivons dans une société encore à dominance patriarcale, dans
              laquelle nos jeunes filles, dès 14 ans, se font traiter dans la
              rue de «bonnes», de «belles à baiser», etc. Lorsqu’elles rejettent
              les garçons qui les harcèlent, elles se font injurier, bousculer.
              L’inverse est très rare. La tolérance de la société à ces
              comportements est le creuset d’une violence dans le cadre du
              couple. Tant que nous accepterons ce genre de comportement, les
              femmes seront menacées. Cela dit, la majorité des meurtres ont
              lieu dans le contexte de violence punitive ou complémentaire, avec
              une mise sous emprise préalable de la victime.
            </p>
            <p>
              <b>Que faire?</b>
            </p>
            <p>
              Il faut un changement drastique de paradigme culturel. Il faut
              apprendre à nos enfants, garçons et filles, le respect mutuel
              entre les genres. Le plus tôt possible. Il faut enseigner la
              tolérance et l’égalité dans les préaux d’école, dès la maternelle.
            </p>
            <p>
              <b>
                C’est un projet à long terme. Que pouvons-nous faire plus
                rapidement pour protéger ces femmes?
              </b>
            </p>
            <p>
              La tolérance zéro au niveau pénal. La punition est souvent la
              seule chose que comprennent les auteurs de violence punitive. Il
              faut leur mettre des limites claires et précises. À défaut qu’ils
              puissent intégrer qu’ils n’ont aucun droit de frapper et, pis
              encore, de tuer leur femme, ils se retiennent par peur des
              conséquences. Il faut donc leur montrer que s’ils frappent ils
              seront sanctionnés immédiatement, voire incarcérés. Ce principe
              est appliqué dans la loi sur la circulation routière. Pourquoi pas
              dans le domaine de la violence domestique? Il faut une Via sicura
              de la violence conjugale.
            </p>
            <p>
              <b>Emprisonner à partir de quand? Dès la première gifle?</b>
            </p>
            <p>
              Et pour combien de temps? Personne n’a encore trouvé de réponse
              idéale. Dans la pratique, les autorités ne sanctionnent que quand
              il y a récidive d’un acte grave qui atteste d’un danger grave. Or
              la pratique nous montre que c’est déjà trop tard, lorsque la
              violence se manifeste. Il faut donc intervenir avant. Il faut être
              attentif, réagir dès les premiers signes de maltraitance. Les
              magistrats, les policiers, les avocats, les fonctionnaires, les
              médecins et autres soignants doivent pouvoir reconnaître les
              signes annonciateurs et prendre les mesures, dont celles, pénales,
              qui s’imposent. Il y a un effort de formation à faire dans ce
              sens.
            </p>
            <p>
              <b>
                Il y a aussi la justice civile, qui permet l’interdiction de
                périmètre…
              </b>
            </p>
            <p>
              La mesure d’éloignement est utile, mais elle est insuffisante. Les
              auteurs de violence ne respectent pas cette interdiction de
              périmètre. Les victimes elles-mêmes peinent à le faire. Elles
              acceptent parfois le retour de leur agresseur dans le foyer
              familial. Elles pensent devoir le faire pour le bien des enfants,
              pour calmer la situation, ou elles le font pour garder un œil sur
              l’auteur et vérifier qu’elles ne sont pas en danger. C’est la
              seule solution qu’elles trouvent dans une société qui est peu
              protectrice. L’auteur qui transgresse l’interdiction est un
              danger. Il doit être remis à l’ordre. Mais il est impossible de
              mettre un policier derrière chaque femme menacée.
            </p>
            <p>
              <b>
                Vous parlez de signes annonciateurs. Pouvez-vous développer?
              </b>
            </p>
            <p>
              Le féminicide conjugal est l’aboutissement d’une série signes
              précurseurs qui annoncent le drame. C’est rarissime qu’il n’y en
              ait pas. Il y a les actes brutaux qui sont des signaux évidents.
              Nous sommes alors dans une situation à haut risque, et des mesures
              drastiques doivent être prises. Mais il n’y a pas que cela. Les
              femmes menacées sont sous emprise. Elles pensent vivre un amour
              fou, malgré le danger. Leur agresseur les isole, les menace, les
              rabaisse. Les victimes peinent à reconnaître ce qu’elles
              subissent. Et, lorsqu’elles dénoncent la situation, elles peuvent
              se rétracter parce qu’elles ont peur ou sont menacées. Ce sont
              autant de signes qui laissent penser que le mécanisme est
              enclenché.
            </p>
            <p>
              <b>Qu’est-ce que l’emprise?</b>
            </p>
            <p>
              L’emprise est un type de relation instauré par un auteur de
              violences totalement dépourvu d’empathie. Ses besoins priment sur
              ceux de sa victime, et sur ceux des enfants. Pour obtenir qu’on le
              comble, tous les moyens sont bons: de susciter la pitié de l’autre
              à tous les types de violences. Il y a deux types de réactions face
              à un pervers. Des femmes partent tout de suite, ce qui ne les met
              pas à l’abri du harcèlement, mais les protège de l’agression.
              D’autres, en revanche, restent parce qu’elles pensent que leur
              gentillesse, leur attention, pourra calmer l’autre, le rassurer.
              Elles ont envie de donner de l’amour, elles pensent devoir
              surmonter cette épreuve pour vivre leur relation. Il y a un déni
              automatique face à l’horreur. C’est une protection de soi. Elle
              est dans les filets de l’auteur et peine à en sortir. Si elle
              était informée des mécanismes mis en œuvre par l’autre, elle
              serait mieux armée pour ne pas laisser l’emprise s’installer. Une
              fois l’emprise installée, même si elle en prend conscience, elle
              est en danger, qu’elle reste ou qu’elle parte sans protection.
            </p>
            <p>
              <b>Y a-t-il un profil type de meurtrier?</b>
            </p>
            <p>
              Les chiffres montrent que 98% des féminicides conjugaux sont
              commis par des auteurs d’emprise (majoritairement des pervers).
              J’entends par là un homme qui est peu outillé psychiquement pour
              percevoir l’existence de l’autre. Il est centré sur sa propre
              souffrance, ses besoins. Il utilise les autres pour sa survie,
              sans s’intéresser aux besoins de l’autre. Ces auteurs ont
              généralement un sentiment de toute-puissance. Ils se sentent
              agressés par tout dans la vie, ils trouvent que la société n’est
              pas assez reconnaissante envers eux. Tout ce qui ne correspond pas
              à leur besoin et à leur désir est vécu comme une agression
              extérieure et ils se sentent légitimes à frapper. Un exemple en
              est un auteur qui exerce des violences sur sa femme parce qu’elle
              n’est pas capable de faire que leur nourrisson ne pleure pas!
            </p>
            <p>
              <b>Que faire pour les soigner?</b>
            </p>
            <p>
              Nous ne pouvons pas faire grand-chose contre ces pervers, à part
              les punir, informer les victimes et les aider à les quitter. Ces
              meurtriers pervers ne sont pas malades. Ils sont handicapés
              socialement. Ce sont des blessés de la vie. Il n’y a pas de
              traitement, pas de médicament. Ils sont les seuls à pouvoir
              prendre conscience de leur attitude inadaptée. Mais pour cela ils
              doivent assumer. Ils doivent reconnaître leurs actes, leur
              responsabilité, l’impact sur leur entourage et ressentir la
              volonté de changement. Certains y parviennent en partie. Ils
              regrettent, mais ça ne va pas plus loin. C’est une reconnaissance
              de façade. Ils restent au fond d’eux convaincus que la responsable
              de la violence, c’est la victime qui les provoque. Mais ce qu’ils
              vivent comme provoquant, ce sont des événements bénins de la vie.
              Je n’ai jamais vu de vraie remise en question chez un pervers.
            </p>
            <p>
              <b>
                En moyenne, il y a une quinzaine de féminicides conjugaux depuis
                2009. Cette régularité est-elle désespérante?
              </b>
            </p>
            <p>
              Au niveau des auteurs, c’est assez déprimant en effet. Ça prouve,
              comme je l’ai dit, qu’il faut un vrai engagement de tous les
              partenaires sociaux plus vite! Mais dans le cadre de la violence
              conjugale, avant le meurtre, nous avons l’impression. aux
              Boréales, de pouvoir faire beaucoup avec les femmes et les enfants
              qui souffrent de cette violence conjugale et viennent nous voir.
              Lorsque nous recevons les victimes, le premier jour, elles sont
              délabrées. Mais elles peuvent rapidement, en quelques mois,
              reprendre leur vie en main. À chaque fois, c’est une grande
              victoire. Celle-ci est possible grâce aux collaborations avec le
              réseau très actives dans le canton.
            </p>
          </SlidingPane>

          <Footer
            articleId={ARTICLE_ID}
            inverted
            locale='fr'
            hidePortfolioTeaser
            title='Comment jugez-vous ce contenu?'
            mailTo='dominique.botti@tamedia.ch'
            questions={[
              'Était-il informatif?',
              'La mise en forme vous plaît-elle?'
            ]}
            credits={[
              [
                'Textes et recherches',
                'Dominique Botti, Roland Gamp et Philippe Stalder'
              ],
              ['Illustration et conception', 'Patrick Vögeli']
            ]}
          />
        </div>
      </>
    )
  }
}

// const QandA = ({ q }) => (
//   <div className='qa'>
//     {/* <div className='question'>{q.p}</div> */}
//     {/* <div className='answer'>{q.a}</div> */}
//   </div>
// )
